import styled from '@emotion/styled/macro';

export const ActionPanel = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));
